/*
 * Module for a list of topics
 */

define([
  "jquery",
  "marionette",
  "messaging/messenger",
  "./userListView",
  "modules/shared/sortableList/sortableListModule",
  "modules/admin/userAdministration/userDetails/userDetailsModalModule",
], function ($, Marionette, Messenger, UserListView, SortableListModule, UserDetailsModalModule) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "userList";
      this.region = options.region;
      this.namespace = options.namespace;
      this.namespacePrefix = this.namespace ? this.namespace + ":" : "";
      this._setUpVents();
    },
    show: function (users) {
      const headers = Messenger.reqres.request("user:list:headers");

      this._prepareUserRolesStr(users);

      Messenger.onSave(function () {
        Messenger.saveAttempted(true);
      }, this);

      const extendedEvents = {
        "click .deleteUser": function () {
          const currentUser = Messenger.reqres.request("user");
          const model = this.model;
          if (currentUser.get("loginName") != model.get("userLogin")) {
            Messenger.yesNoDialog(
              $.t("admin.userAdministration.confirmDeleteUser", {
                userName: model.get("userFullName"),
              }),
              {
                yes: function () {
                  Messenger.vent.trigger("track:interaction", {
                    action: "Delete User",
                    id: model.id,
                    idType: "User",
                    object: "User",
                  });
                  model.deleteModel();
                },
              },
              this,
            );
          } else {
            Messenger.okDialog("admin.userAdministration.deletedOwnUser");
          }
        },
      };

      this.layout = new UserListView.userListLayout({ collection: users });
      this.usersList = this.addSubModule(
        new SortableListModule({
          region: this.layout.users,
          headers: headers,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          namespace: this.namespace,
          extendedEvents: extendedEvents,
        }),
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews(users);
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _prepareUserRolesStr: function (users) {
      users.each(function (user) {
        const userKbRolesMap = user.get("kbToKbRolesMap");
        let userRolesStr = "";
        if (user.get("isAdmin")) {
          user.set("userRoles", "Admin");
        } else {
          if (userKbRolesMap) {
            for (let kbId in userKbRolesMap) {
              const roleList = userKbRolesMap[kbId];
              if (roleList.length > 0) {
                userRolesStr += roleList[0].kbName + ">";
                userRolesStr += _.pluck(roleList, "name").join("; ");
                userRolesStr += "; ";
              }
            }
          }
          user.set("userRoles", userRolesStr);
        }
      }, this);
    },
    _showSubViews: function (activeUsers) {
      this.usersList.show(activeUsers);
    },
    _setUpVents: function () {
      //a row was selected in the sortable list (prepend namespace)
      Messenger.vent.on(
        this.namespacePrefix + "selected:row",
        function (model) {
          Messenger.vent.trigger(
            "show:modal",
            UserDetailsModalModule,
            {
              editMode: true,
            },
            model,
            {
              title: "User Details",
              closeButton: false,
              closeOnBackgroundClick: false,
              modalWidth: "900px",
              trackInteraction: {
                action: "Edit User",
                id: model.id,
                idType: "User",
                object: "User",
              },
            },
          );
        },
        this,
      );
    },
  });
});
